export class NumberCounter extends HTMLElement {
  constructor() {
    super();

    if (theme.config.motionReduced) return;

    if (!theme.config.isTouch || Shopify.designMode) {
      Motion.inView(this, this.init.bind(this), { margin: "200px 0px 200px 0px" });
    } else {
      new theme.initWhenVisible(this.init.bind(this));
    }
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    const matches = this.textContent.trim().match(/\d+(?:[,. ]\d+)*/);
    const toReplace = matches[0].replace(/[,\. ]+/, "");

    Motion.animate(
      (progress) => {
        const formattedString = Math.round(progress * parseInt(toReplace))
          .toLocaleString()
          .replace(/,/g, ", ");
        this.textContent = progress.toLocaleString().replace(/,/g, ", ") === 1 ? matches[0] : formattedString;
      },
      { duration: parseFloat(this.getAttribute("data-duration")), easing: [0.16, 1, 0.3, 1] },
    );
  }
}
customElements.define("number-counter", NumberCounter);
